import React from 'react'
import { Toast } from 'antd-mobile'
import Error from '../components/Error'

const obj = (typeof document !== 'undefined')&& document.getElementById('loader_Container')
const loading = {
  show: (fullScreen) => {
    obj.classList.remove('loader_hide', 'loader_hiding', 'loader_fullScreen')
    if (fullScreen) {
      obj.classList.add('loader_fullScreen')
    }
  },
  hide: () => {
    obj.classList.add('loader_hiding')
    setTimeout(() => {
      obj.classList.add('loader_hide')
    }, 200)

  },
  error: (msg) => {
    Toast.info(
      <Error errMsg={msg} />,
      null)
  }
}

export default loading
